/****************************************
	Focus Outline
*****************************************/
$(function () {
	var $body = $('body');
	function usingKeyboard(e) {
		if (e.keyCode === 9) {
			$body
				.removeClass('mouseEvents')
				.off('keydown.outline')
				.one('mousedown.outline', usingMouse);
		}
	}
	function usingMouse(e) {
		$body
			.addClass('mouseEvents')
			.on('keydown.outline', usingKeyboard);
	}
	$body.one('mousedown.outline', usingMouse);
});
